import "./SliderFile.css";

import React, { useEffect } from "react";
import SliderHome from "./SliderHome";

const File = ({ in_data }) => {
  useEffect(() => {}, [in_data]);
  return (
    <div>
      <ul>
        {in_data.keyResult && in_data.keyResult.length > 0 && (
          <div className="keyResults">
            <b>Key Results</b>
          </div>
        )}
        {in_data.keyResult &&
          in_data.keyResult.map((keypoint) => {
            return (
              <li className="slider111">
                <div>{keypoint.data}</div>
                <div className="rightSection">
                  <SliderHome
                    value={keypoint.data_name}
                    min={keypoint.min}
                    max={keypoint.max}
                    data_type={keypoint.data_type}
                  />
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default File;
